<template>
  <div
    class="w-full h-full flex flex-col items-center justify-center gap-2 bg-fill-2 text-text-2"
  >
    <Icon
      :icon="icon"
      :class="classNames"
    />
    <div class="text-sm font-semibold">
      {{ text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  isLoading?: boolean
  isFailed?: boolean
  text?: string
}>()

const icon = computed(() => {
  if (props.isLoading) {
    return 'sky:ic-loading'
  }
  return 'sky:ic-dislike-pic'
})
const classNames = computed(() => {
  if (props.isLoading) {
    return 'animate-spin w-8 h-8'
  }
  return 'w-8 h-8'
})
</script>
